import anime from 'animejs';

class SidebarNavigation {
    constructor(element) {
        this.sidebarNavigation = element;

        if (!this.sidebarNavigation) return;

        this.openTriggers = document.querySelectorAll(this.sidebarNavigation.dataset.openTrigger);
        this.closeTriggers = this.sidebarNavigation.querySelectorAll('.js-sidebar-navigation-close');
        this.sidebarBackground = this.sidebarNavigation.querySelector('.js-sidebar-navigation-background');
        this.sidebarMenu = this.sidebarNavigation.querySelector('.js-sidebar-navigation-menu');
        this.sidebarMenuItems = this.sidebarNavigation.querySelectorAll('.js-sidebar-navigation-menu-items');

        this.isOpen = false;

        this.initEvents();
    }

    initEvents() {
        this.closeTriggers.forEach((element) => {
            element.addEventListener('click', () => {
                if (this.isOpen) {
                    this.close();
                }
            });
        });

        this.openTriggers.forEach((element) => {
            element.addEventListener('click', () => {
                if (!this.isOpen) {
                    this.open();
                }
            });
        });
    }

    open() {
        this.sidebarNavigation.classList.add('active');
        this.sidebarBackground.style.opacity = 1;
        this.sidebarMenu.style.transform = 'translateX(100%)';

        anime({
            targets: this.sidebarMenu,
            translateX: 0,
            duration: 100,
            easing: 'easeInOutExpo',
        });

        this.isOpen = true;
        document.querySelector('body').style.overflow = 'hidden';
    }

    close() {
        const timeline = anime.timeline({
            duration: 200,
            easing: 'linear',
            complete: (() => {
                this.sidebarNavigation.classList.remove('active');
            }),
        });

        timeline.add({
            targets: this.sidebarMenu,
            translateX: (document.body.clientWidth),
        }).add({
            targets: this.sidebarBackground,
            opacity: 0,
        });

        this.isOpen = false;
        document.querySelector('body').style.overflow = '';
    }
}

const sidebarNavigation = {
    init() {
        const sidebars = document.querySelectorAll('.js-sidebar-navigation');
        sidebars.forEach((element) => {
            this.sidebar = new SidebarNavigation(element);
        });
    },
};

export default sidebarNavigation;
